module.exports = __webpack_public_path__ + "img/knowledge.4adb3b08.png";